module.exports = __webpack_public_path__ + "img/nav-nota.97c85f6c.svg";